import { render } from "./diyFoodsModel.vue?vue&type=template&id=002ddcda"
import script from "./diyFoodsModel.vue?vue&type=script&lang=js"
export * from "./diyFoodsModel.vue?vue&type=script&lang=js"

import "./diyFoodsModel.vue?vue&type=style&index=0&id=002ddcda&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__